import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Modal,
  Button,
  Form,
  Spinner,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import LeftNav from "../../common/leftnav";
import authService from "../../../services/authService";
import { useUser } from "../../../context/UserContext";

const Faqs = () => {
  const { token } = useUser();

  const [showFaq, setShowFaq] = useState(false);
  const [loading, setLoading] = useState(false);
  const [faqs, setFaqs] = useState([]);

  const handleCloseFaq = () => setShowFaq(false);
  const handleShowFaq = () => setShowFaq(true);

  // Fetch FAQs from the server when the component mounts
  useEffect(() => {
    const fetchFaqs = async () => {
      setLoading(true);
      try {
        const data = await authService.updateInstructions({}, token);
        setFaqs(data.faqResponses || []);
      } catch (error) {
        console.error("Failed to fetch FAQs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, [token]);

  // Handle input change
  const handleChange = (index, field, value) => {
    const updatedFaqs = [...faqs];
    updatedFaqs[index][field] = value;
    setFaqs(updatedFaqs);
  };

  // Add new question-answer pair
  const addFAQ = () => {
    setFaqs([...faqs, { question: "", answer: "" }]);
  };

  const removeFAQ = (index) => {
    const updatedFaqs = faqs.filter((_, i) => i !== index);
    setFaqs(updatedFaqs);
  };

  const handleSaveFaqs = async () => {
    setLoading(true);
    const payload = { faqResponses: faqs };
    try {
      const response = await authService.updateInstructions(payload, token);
      setFaqs(response.faqResponses);
    } catch (error) {
      console.error("Failed to save FAQs:", error);
    } finally {
      setLoading(false);
      handleCloseFaq();
    }
  };

  const navigate = useNavigate();

  return (
    <div className="d-flex">
      <LeftNav />
      <Container
        fluid
        className="instructions-content flex-grow-1 p-4 bg-light"
      >
        <Row>
          <Col>
            <h2 className="fs-five-title fw-bold">Agent Settings</h2>
            <p className="gray-color">
              Customize Nouraa to enhance your business call experience.
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="p-4 mt-4 border-0">
              <div>
                <Link
                  to="/agent_settings"
                  className="text-decoration-none purple-color fw-bold mb-4"
                  onClick={() => {
                    setLoading(true);
                    navigate("/agent_settings");
                  }}
                >
                  <img
                    src="../assets/arrow-left.svg"
                    alt="Arrow Right"
                    className="me-1"
                  />
                  Go Back
                </Link>
                <div className="d-flex justify-content-between align-items-center mt-4">
                  <h2 className="fs-two fw-bold">
                    <img
                      src="../assets/faq.svg"
                      alt="Arrow Right"
                      className="me-2"
                    />
                    FAQs
                  </h2>
                  <Button
                    variant="link"
                    onClick={handleShowFaq}
                    className="purple-color text-decoration-none fw-bold"
                  >
                    <img
                      src="/assets/edit-1.svg"
                      alt="Right Icon"
                      className="me-2 pb-1"
                    />
                    Edit
                  </Button>
                </div>
                <p className="gray-color">
                  Provide instant answers to common questions
                </p>
                <hr className="mb-4 border-dark-subtle" />
                {loading ? (
                  <div className="text-center">
                    <Spinner animation="border" />
                  </div>
                ) : (
                  <div>
                    {faqs.map((faq, index) => (
                      <div key={index}>
                        <p className="fw-bold my-4">Question {index + 1}</p>
                        <p className="mb-1">
                          <strong>{faq.question}</strong>
                        </p>
                        <p>{faq.answer}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Card>
          </Col>
        </Row>

        <Modal show={showFaq} onHide={handleCloseFaq} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title className="fs-three bg-light">FAQ</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <Form>
              <h6>Questions</h6>
              <div className="mb-3 border rounded">
                {faqs.map((faq, index) => (
                  <div key={index} className="mb-2  p-3 ">
                    <Form.Control
                      type="text"
                      placeholder="Question"
                      className="mb-2"
                      value={faq.question}
                      onChange={(e) =>
                        handleChange(index, "question", e.target.value)
                      }
                    />
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Answer"
                      value={faq.answer}
                      onChange={(e) =>
                        handleChange(index, "answer", e.target.value)
                      }
                    />
                    {faqs.length > 1 && (
                      <Button
                        variant="outline-danger"
                        size="sm"
                        className="mt-2"
                        onClick={() => removeFAQ(index)}
                      >
                        Remove
                      </Button>
                    )}
                  </div>
                ))}
                <Button
                  variant="link"
                  className="text-decoration-none py-3 purple-color fw-bold"
                  onClick={addFAQ}
                >
                  <img
                    src="/assets/plus-blue.svg"
                    alt="Right Icon"
                    className="me-1"
                  />{" "}
                  Add another
                </Button>
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <small className="text-muted">
              Changes will go live immediately
            </small>
            <Button
              variant="light"
              className="fw-bold"
              onClick={handleCloseFaq}
            >
              Cancel
            </Button>
            <Button
              variant="none"
              className="ms-2 bg-purple-color fw-bold text-white"
              onClick={handleSaveFaqs}
              disabled={loading}
            >
              {loading ? <Spinner animation="border" size="sm" /> : "Save"}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
};

export default Faqs;
